/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const StatusTcpConnectionDisabled = props => (
  <svg viewBox="0 0 128 128" width="128" height="96" {...props}>
        <g transform="matrix(0.1875 0 0 0.1875 10.000002 -0)">
            <path d="M569.517 440.013C 587.975 472.007 564.806 512 527.94 512L527.94 512L48.054 512C 11.117001 512 -11.945 471.945 6.477001 440.013L6.477001 440.013L246.423 23.985C 264.89 -8.023998 311.143 -7.9659996 329.577 23.985L329.577 23.985L569.51697 440.013L569.517 440.013zM288 354C 262.595 354 242 374.595 242 400C 242 425.405 262.595 446 288 446C 313.405 446 334 425.405 334 400C 334 374.595 313.405 354 288 354zM244.327 188.654L251.745 324.654C 252.092 331.018 257.354 336 263.727 336L263.727 336L312.27298 336C 318.64597 336 323.908 331.018 324.25497 324.654L324.25497 324.654L331.67297 188.65399C 332.04797 181.78 326.57498 175.99998 319.69098 175.99998L319.69098 175.99998L256.30798 175.99998C 249.42398 175.99998 243.95198 181.77998 244.32698 188.65399z" />
        </g>
    </svg>
);

export default extendIcon(StatusTcpConnectionDisabled);
